<template>
    <div class="timezone-picker">
        <div class="search-panel">
            <input maxlength="128" :placeholder="$t('chatbotv2.typeSearchValue')" type="text" v-model="search" />
            <span class="material-icons"> search </span>
        </div>
        <div class="entity-list">
            <div class="entity-select">
                <div class="text-uppercase caption">Timezones</div>
                <div
                    class="picker-item"
                    v-for="item of getFilteredItems()"
                    @click="pick(item.value)"
                    :class="{ active: value === item.value }"
                >
                    <span class="name">{{ item.description }} </span>
                    <span class="description">{{ item.example }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment-timezone";
import _ from "lodash";

export default {
    name: "TimezonePicker",
    props: {
        value: {
            type: String,
            required: true,
        },
    },
    data() {
        const momentTimezoneList = moment.tz.names();
        return {
            list: momentTimezoneList.map((x) => ({
                value: x,
                description: x,
                example: "",
            })),
            clone: _.cloneDeep(this.value),
            search: "",
        };
    },
    methods: {
        pick(value) {
            this.clone = value;
        },
        getFilteredItems() {
            const q = this.search.toLowerCase().trim();
            if (q.length === 0) return this.list;
            else return this.list.filter((x) => x.description.toLowerCase().includes(q));
        },
    },
    computed: {
        ...mapState({}),
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue, oldValue) {
                this.$emit("input", newValue);
            },
        },
        value(newValue) {
            if (newValue !== this.clone) this.clone = _.cloneDeep(newValue);
        },
    },
};
</script>

<style lang="scss" scoped>
.timezone-picker {
    background: #fff;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    max-height: 600px;
    min-height: 200px;
    user-select: none;
    width: 100%;
    padding: 5px;

    .search-panel {
        align-items: center;
        border-bottom: 1px solid #e8eef3;
        display: flex;
        flex-shrink: 0;
        position: relative;
        width: 100%;

        input {
            background: transparent;
            border: 0;
            font-size: 16px;
            height: 40px;
            line-height: 20px;
            padding-left: 45px;
            padding-right: 15px;
            width: 100%;
        }

        span {
            color: #9ba6b3;
            font-size: 18px;
            left: 15px;
            pointer-events: none;
            position: absolute;
            -webkit-transition: color 0.3s;
            transition: color 0.3s;
        }
    }

    .entity-list {
        flex-grow: 1;
        overflow-x: hidden;
        overflow-y: auto;
        padding: 15px 0;
    }

    .entity-select {
        .caption {
            margin-bottom: 10px;
            padding: 0 15px;
            color: #9ba6b3;
            font-weight: 600;
            font-size: 16px;
            line-height: 20px;
        }
    }

    .picker-item {
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        cursor: pointer;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        height: 32px;
        padding: 0 15px;
        -webkit-transition: background-color 0.2s, opacity 0.2s;
        transition: background-color 0.2s, opacity 0.2s;

        &.active {
            color: #006cff !important;

            .material-icons,
            .name,
            .description {
                color: #006cff !important;
            }
        }

        &:hover {
            background-color: #f0f4f7;
        }

        .material-icons {
            color: #647283;
            font-size: 15px;
            margin-right: 11px;
        }

        .name {
            color: #22272d;
            font-size: 16px;
            font-weight: 400;
            line-height: 20px;
            margin-right: 20px;
        }

        .description {
            color: #9ba6b3;
            font-size: 15px;
            line-height: 19px;
            margin-left: auto;
            overflow: hidden !important;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }
}
</style>
